module.exports = __webpack_public_path__ + "img/yezhupan.a75ed4a5.svg";